import { render, staticRenderFns } from "./33.vue?vue&type=template&id=33a63e57&scoped=true&"
var script = {}
import style0 from "./33.vue?vue&type=style&index=0&id=33a63e57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a63e57",
  null
  
)

export default component.exports